export default __webpack_public_path__ + "static/media/sardinia_flag.a55bdff2.png";